import { ApiAPITokenResponse, ApiProject } from "@incendium/api";
import { APITokenService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchAPITokens = async (project: ApiProject) => {
  const res = await APITokenService.aPITokenServiceListAPITokens({
    clientId: project.clientId as number,
    projectId: project.id as number,
  });
  return res.result || [];
};

export const useAPITokens = () => {
  const { state, setState } = useProjectSharedState("apiTokens", [], fetchAPITokens);

  return {
    tokens: state as ApiAPITokenResponse[],
    setTokens: setState,
  };
};
